import { observable, makeObservable } from 'mobx'
import { PermissionSet } from '../dtos/permissions'
import { TeamRoleDTO } from '../dtos/team-role'
import { Model } from 'infra/model'
import { Id } from 'types/definitions'
import { DateZero } from 'utils/date-util'
import once from 'lodash/once'

export default class TeamRole extends Model<TeamRoleDTO, TeamRole> {
  @observable name = ''
  @observable isOwnerRole = false
  @observable description = ''
  @observable permissions: PermissionSet = {}
  @observable workspaceId = Id.none
  @observable dateCreated: Date = DateZero()
  @observable dateModified: Date = DateZero()
  id = Id.none

  constructor() {
    super()

    makeObservable(this)
  }

  static get none() {
    return lazyNone()
  }

  parse(attrs: Partial<TeamRoleDTO>): Partial<TeamRole> {
    return {
      id: attrs.id,
      isOwnerRole: attrs.is_owner_role,
      name: attrs.name,
      description: attrs.description,
      permissions: attrs.permissions,
      workspaceId: attrs.workspace_id,
    }
  }
}

const lazyNone = once(() =>
  new TeamRole().set({
    name: 'None',
  }),
)
